"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbitalCleanup = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const Resources_1 = require("../../Resources");
const CardRenderer_1 = require("../render/CardRenderer");
class OrbitalCleanup extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ORBITAL_CLEANUP,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 14,
            metadata: {
                cardNumber: 'X08',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Gain 1 M€ per Science tag you have.', (eb) => {
                        eb.empty().startAction.megacredits(1).slash().science().played;
                    }).br;
                    b.production((pb) => {
                        pb.megacredits(-2);
                    });
                }),
                description: 'Decrease your M€ production 2 steps.',
                victoryPoints: 2,
            },
        });
    }
    canPlay(player) {
        return player.getProduction(Resources_1.Resources.MEGACREDITS) >= -3;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, -2);
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, player.getTagCount(Tags_1.Tags.SCIENCE), { log: true });
        return undefined;
    }
    getVictoryPoints() {
        return 2;
    }
}
exports.OrbitalCleanup = OrbitalCleanup;
//# sourceMappingURL=OrbitalCleanup.js.map